import { showRememberPrompt } from '../../utilities/togglePrompt.js'

export function obfuscateEmail(emailAddress) {
  //copious use of string literals here to prevent the small chance that string concat with + doesn't try to cast as integers and do addition
  const addressArray = emailAddress.split('@')
  const email = addressArray[0]
  let obscureEmail

  switch (email.length) {
    case 1:
      obscureEmail = email
      break
    case 2:
      obscureEmail = `${email.slice(0, 1)}*`
      break
    default:
      let numToKeep = 1
      if(email.length >= 5) numToKeep = 2
      let firstPart = email.slice(0, numToKeep)
      const lastPart = email.slice(-numToKeep)

      while(firstPart.length < email.length - numToKeep) {
        firstPart = `${firstPart}*`
      }

      obscureEmail = `${firstPart}${lastPart}`
      break
  }

  return `${obscureEmail}@${addressArray[1]}`
}

function getAuthInfoCookie () {
  return document.cookie.split(';').find((item) => (item.indexOf('authInfo') !== -1))
}

function getCookie() {
  try {
    return JSON.parse(
      window.atob(
        getAuthInfoCookie().split('=')[1]
      )
    )
  } catch(error) {
    return {};
  }
}


export function maybeShowRememberPrompt () {
  const authInfo = getCookie()
  if (authInfo.mfaComplete) {
    showRememberPrompt()
  }
}
